import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const DirectionService = {
    async getOptions(){
        try{
            return await $api.get(`${API_URL}/direction/options`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async setHospital(data){
        try{
            return await $api.post(`${API_URL}/direction/hospital`, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getHospital(data){
        try{
            return await $api.get(`${API_URL}/direction/hospital?${data}&registrationType=COMPLETED`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async setAntibodies(data){
        try{
            return await $api.post(`${API_URL}/direction/antibodies`, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async setDepartment(data){
        try{
            return await $api.post(`${API_URL}/direction/department`, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getDirections(data){
        try{
            return await $api.post(`${API_URL}/direction/department`, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async createDirection(data){
        try{
            return await $api.post(`${API_URL}/direction/create`, {...data});
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getDirectionHTML(id){
        try{
            return await $api.get(`${API_URL}/direction/manage/${id}/generate/direction-html`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },async getDirectionHTML1(id){
        try{
            return await $api.get(`${API_URL}/direction/manage/${id}/generate/result-html`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getDirectionPdf(id){
        try{
            return await $api.get(`${API_URL}/direction/manage/${id}/generate/result-pdf`, {responseType: 'arraybuffer'})
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async createClinic(data){
        try{
            return await $api.post(`${API_URL}/direction/hospital`, {...data});
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async editClinic(data){
        try{
            return await $api.put(`${API_URL}/direction/hospital/` + data.id, {...data});
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getDirectionDataByParam(params){
        try{
            return await $api.get(`${API_URL}/direction/active-doc?search=${params}`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getContractForClinic(id){
        try{
            return await $api.get(`${API_URL}/direction/hospital/${id}/contracts?status=active`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getContractDataByClinic(id, contractId){
        try{
            return await $api.get(`${API_URL}/direction/hospital/${id}/contracts/${contractId}/available`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async updateDirectionFull(id, data){
        try{
            return await $api.put(`${API_URL}/direction/manage/${id}/full`, {...data})
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
};